import {
  epochSecondsOf,
  instantFromEpochSeconds,
} from "../../../../../../../../utils/temporal";
import { Temporal } from "@js-temporal/polyfill";
import { translateIfPresent } from "../../../../../../../../locales/i18n";

export const formatDate = (epochSeconds: number, timezone: string): string => {
  const now = Temporal.Now.instant().toZonedDateTimeISO(timezone);
  const date =
    instantFromEpochSeconds(epochSeconds).toZonedDateTimeISO(timezone);

  const diffSeconds = epochSecondsOf(now) - epochSecondsOf(date);
  const diffMinutes = Math.abs(diffSeconds) / 60;
  const diffHours = Math.abs(diffSeconds) / 3600;

  if (diffSeconds < 60) {
    return translateIfPresent("general.recently", "recently");
  } else if (diffMinutes < 60) {
    return `${Math.round(diffMinutes)} ${translateIfPresent(
      "general.minute(s) ago",
      "minute(s) ago",
    )}`;
  } else if (diffHours < 24) {
    return `${Math.floor(diffHours)} ${translateIfPresent(
      "general.hour(s) ago",
      "hour(s) ago",
    )}`;
  } else {
    return `${translateIfPresent("general.on", "on")} ${date
      .toPlainDateTime()
      .toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
        timeZone: timezone,
      })}`;
  }
};
